import { Injectable } from '@angular/core';
import { Floor } from '@miq/domain/pv';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class PVFloorSpaceDataHelper {
  private spaceData = new BehaviorSubject<Floor>(null);
  spaceData$ = this.spaceData.asObservable();

  setData(d: Floor) {
    this.spaceData.next(d);
  }

  getData(): Observable<Floor> {
    return this.spaceData.asObservable();
  }

  unsubscribe() {
    this.spaceData.unsubscribe();
  }
}
